import { memo } from 'react'
import { ReactElementType } from 'react-window'

import { TextWithLinks } from '@modules/profile/TextWithLink'

import { FieldSectionContainer, FieldText, FieldTitle } from './ResultProfileList.styles'

export interface FieldSectionProps {
  fields: {
    value?: string
    label?: string
  }[]
  wrapper: ReactElementType
}

const FieldSectionRow = ({ fields, wrapper: Wrapper }: FieldSectionProps) => {
  if (!fields?.length) {
    return null
  }

  return (
    <Wrapper>
      {fields.map(({ value, label }) => {
        if (!value) {
          return null
        }

        return (
          <FieldSectionContainer key={label + value}>
            {!!label && <FieldTitle variant="h3">{label}</FieldTitle>}
            <FieldText variant="body1">
              <TextWithLinks text={value} />
            </FieldText>
          </FieldSectionContainer>
        )
      })}
    </Wrapper>
  )
}

export default memo(FieldSectionRow)
